export var BottomSheetType = /* @__PURE__ */ ((BottomSheetType2) => {
  BottomSheetType2["DEFAULT"] = "DEFAULT";
  BottomSheetType2["MODAL"] = "MODAL";
  BottomSheetType2["PERSISTENT"] = "PERSISTENT";
  return BottomSheetType2;
})(BottomSheetType || {});
export var BottomSheetTransitions = /* @__PURE__ */ ((BottomSheetTransitions2) => {
  BottomSheetTransitions2["SLIDE"] = "slide";
  BottomSheetTransitions2["SLIDE_REVERSE"] = "slide-reverse";
  BottomSheetTransitions2["BOTTOM_UP"] = "slide-bottom-up";
  return BottomSheetTransitions2;
})(BottomSheetTransitions || {});
